import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { LinkedInternalTasksResultDto } from './linked-internal-tasks-result-dto';

export class LinkInternalTaskEditorResultDto {
    @Type(() => KeyValueResultDto)
    departmentList: KeyValueResultDto[];

    @Type(() => LinkedInternalTasksResultDto)
    linkedInternalTasks: LinkedInternalTasksResultDto[];

    allowAddNewInternalTask: boolean;
}
